import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const PaymentMethodDistribution = () => {
  const paymentData = [
    {
      method: 'Credit Card',
      amount: 1248560,
      percentage: 43.8,
      transactions: 18450,
      icon: 'CreditCard',
      color: '#2563EB'
    },
    {
      method: 'Digital Wallet',
      amount: 967890,
      percentage: 34.0,
      transactions: 15670,
      icon: 'Smartphone',
      color: '#059669'
    },
    {
      method: 'Bank Transfer',
      amount: 398420,
      percentage: 14.0,
      transactions: 4890,
      icon: 'Building2',
      color: '#D97706'
    },
    {
      method: 'Cash on Delivery',
      amount: 232522,
      percentage: 8.2,
      transactions: 8920,
      icon: 'Banknote',
      color: '#DC2626'
    }
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      const data = payload?.[0]?.payload;
      return (
        <div className="bg-popover border border-border rounded-lg p-3 elevation-2">
          <p className="text-sm font-medium text-foreground mb-2">{data?.method}</p>
          <div className="space-y-1 text-xs">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Amount:</span>
              <span className="font-medium">${data?.amount?.toLocaleString()}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Transactions:</span>
              <span className="font-medium">{data?.transactions?.toLocaleString()}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Share:</span>
              <span className="font-medium">{data?.percentage}%</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-1">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Payment Methods</h3>
          <p className="text-sm text-muted-foreground">Revenue distribution by payment type</p>
        </div>
        <Icon name="CreditCard" size={20} className="text-muted-foreground" />
      </div>
      <div className="h-48 mb-6">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={paymentData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="method" 
              stroke="var(--color-muted-foreground)"
              fontSize={10}
              angle={-45}
              textAnchor="end"
              height={60}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              fontSize={10}
              tickFormatter={(value) => `$${(value / 1000)}k`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar 
              dataKey="amount" 
              fill="var(--color-primary)"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="space-y-3">
        {paymentData?.map((method, index) => (
          <div key={index} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-primary/10 rounded-lg">
                <Icon name={method?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{method?.method}</p>
                <p className="text-xs text-muted-foreground">{method?.transactions?.toLocaleString()} transactions</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold text-foreground">${method?.amount?.toLocaleString()}</p>
              <p className="text-xs text-muted-foreground">{method?.percentage}%</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-2 gap-4 text-center">
          <div>
            <p className="text-lg font-bold text-foreground">47,930</p>
            <p className="text-xs text-muted-foreground">Total Transactions</p>
          </div>
          <div>
            <p className="text-lg font-bold text-foreground">$59.42</p>
            <p className="text-xs text-muted-foreground">Avg Transaction</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodDistribution;